import { SimpleToken } from './token';
import { Mood } from './mood';
import { BookingAttributes } from 'app/common/_types';
import { getDurationInSeconds } from '../_utils/time.util';
import { getMoodByWaitTime } from '../_utils/mood.util';

export interface BranchQueueOverviewBooking extends BookingAttributes {
  id: string;
  tokenId?: string;
  tokenNumber: string;
}

export class BranchQueueOverview {
  public id;
  public name;
  public branchQueueId;
  public integrationType?: string;
  public tokens: Array<SimpleToken>;
  public mood: Mood;
  public bookings: Array<BranchQueueOverviewBooking>;

  setBranchQueueOverviewData(data, mood) {
    this.id = data.id;
    this.name = data.attributes.name;
    this.branchQueueId = data.attributes.branchQueueId;
    this.integrationType = '';
    this.tokens = new Array<SimpleToken>();
    this.mood = mood;
    this.setTokensData(this.tokens, data);

    return [this.id, this.name, this.tokens];
  }

  setTokensData(tokens: SimpleToken[], data) {
    const list = data?.attributes?.tokens?.data || [];
    for (let i = 0; i < list.length; i++) {
      const raw = list[i];
      if (!raw) continue;
      const attrs = raw.attributes || {};
      const createdAt = attrs.createdAt as string | undefined;
      const waitTime = createdAt ? getDurationInSeconds(createdAt) : 0;
      const mood = getMoodByWaitTime(waitTime, this.mood);

      const simple: SimpleToken = {
        id: raw.id,
        tokenNumber: attrs.tokenNumber,
        createdAt,
        status: attrs.status,
        waitTime,
        servingTime: undefined,
        mood,
        originType: attrs.originType,
        branchQueueId: attrs.branchQueueId,
        branchQueueName: attrs.branchQueueName,
        tokenTags: attrs.tokenTags || [],
      };

      tokens.push(simple);
    }
  }
}
